import React from "react";
import { Link } from "react-router-dom";
import { weigthlistaa } from "./../queue/datalist";


const Weigthscaleaa = () => {
  const handleonClick = (id) => {


    if (id === 1) {
    } else if (id === 2) {
    } else if (id === 3) {
    } else if (id === 4) {
    } else if (id === 5) {
    } else if (id === 6) {
    }
  };

  return (
    <div className="container">
      {weigthlistaa &&
        weigthlistaa.length > 0 &&
        weigthlistaa.map((item, index) => (
          <div className=" col-lg-12 mt-2 " key={index}>
            <div className="row d-flex justify-content-center ">
              <div className="col-lg-3 d-flex align-items-center d-flex justify-content-center badge my-2 card">
                <div className="row  d-flex justify-content-center">
                  <div className="col-auto mb-2">
                    <i className= "bi bi-truck text-dark " style={{ fontSize: "35px" }} />
                    <span className="badge text-dark  fs-3 mt-2"> {item.name} </span>
                  </div>
                  
                  <div classname="col-auto  ">
                    <span className="badge rounded-pill bg-warning text-dark fs-6 mx-2">
                    {item.in1}
                    </span>
                    <span className="badge rounded-pill bg-danger fs-6 mx-2">
                    {item.out1}
                    </span>
                    <span className="badge rounded-pill bg-success fs-6 mx-2">
                    {item.success}
                    </span>
                  </div>
                </div>
              </div>

              <div className="card col-lg-4  mx-2 my-2 ">
                <div className="position-absolute top-0 start-50 translate-middle fs-6 badge rounded-pill bg-success">
                  <i className="bi bi-arrow-right-circle me-2" /> {item.in}
                </div>
                <div className="row d-flex justify-content-between my-3 mx-2 ">
                  <span className="fs-5 text-center text-success badge "></span>

                  <div className="row ">
                    <div className="col-lg-6 text-center ">
                    <span className={item.spanA}>
                        <i className="bi bi-arrow-right-circle-fill me-2" />
                        แท่น A
                      </span>
                      <div className="row d-flex justify-content-between  mx-2">
                        <span className={item.badge}>{item.truckin}</span>
                        <span className={item.badge}>{item.offweigth}</span>
                        {/* <span className={item.badge}>{item.program}</span>
                        <span className={item.badge}>{item.cctv}</span> */}
                      </div>
                    </div>
                    <div className="col-lg-6  text-center ">
                      <span className={item.spanA}>
                        <i className="bi bi-arrow-right-circle-fill me-2" />
                        แท่น B
                      </span>
                      <div className="row d-flex justify-content-between  mx-2">
                        <span className={item.badge}>{item.truckin}</span>
                        <span className={item.badge}>{item.offweigth}</span>
                        {/* <span className={item.badge}>{item.program}</span>
                        <span className={item.badge}>{item.cctv}</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card col-lg-4 mx-2  my-2 ">
                <div className="position-absolute top-0 start-50 translate-middle fs-6 badge rounded-pill bg-danger ">
                  <i className="bi bi-arrow-left-circle me-2 " /> {item.out}
                </div>
                <div className="row d-flex justify-content-between my-3 mx-2 ">
                  <div className="row ">
                    <div className="col-lg-6  text-center  ">
                    <span className={item.spanA}>
                        <i className="bi bi-arrow-left-circle-fill me-2" />
                        แท่น C
                      </span>
                      <div className="row d-flex justify-content-between mx-2">
                        <span className={item.badge}>{item.truckin}</span>
                        <span className={item.badge}>{item.offweigth}</span>
                        {/* <span className={item.badge}>{item.program}</span>
                        <span className={item.badge}>{item.cctv}</span> */}
                      </div>
                    </div>
                    <div className="col-lg-6  text-center ">
                    <span className={item.spanA}>
                        <i className="bi bi-arrow-left-circle-fill me-2 " />
                        แท่น D
                      </span>
                      <div className="row d-flex justify-content-between  mx-2 ">
                        <span className={item.badge}>{item.truckin}</span>
                        <span className={item.badge}>{item.offweigth}</span>
                        {/* <span className={item.badge}>{item.program}</span>
                        <span className={item.badge}>{item.cctv}</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
export default Weigthscaleaa;
